import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../../views/client/axiosClient'
import * as salaryConstant from './constants'
import { handleRequest} from '../../../lib/common'
import * as orderAaction from './actions'

function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function* salaryReportDetailNvkdRequestFlow({payload}) {
  try {
    const request = axiosApi().post(
      salaryConstant.SALARY_REPORT_DETAIL_NVKD_API,
      payload
    )
    // grab the client from our action
    const { data } = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(orderAaction.salaryReportDetailNvkdSuccess(data))

  } catch (error) {
    yield put(orderAaction.salaryReportDetailNvkdError(error))
  }
}
function* salaryReportDetailListRequestFlow({payload}) {
  try {
    const request = axiosApi().post(
      salaryConstant.SALARY_REPORT_DETAIL_LIST_API,
      payload
    )
    // grab the client from our action
    const { data }  = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(orderAaction.salaryReportDetailListSuccess(data))

  } catch (error) {
    yield put(orderAaction.salaryReportDetailListError(error))
  }
}
function* reportExportXlsRequestFlow({ payload, callback }) {
  const url = salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_API + "?st=" + payload.tu_ngay + "&ed=" + payload.den_ngay + "&kd=" + payload.listNvkd + "&tt=" + payload.trangThai+ "&isTDV=" + payload.isTDV;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );
  try {
    // grab the client from our action
    const { data } = yield call(handleFileRequest, request)
    // dispatch the action with our widgets!
    yield put(orderAaction.reportExportXlsSuccess(data))
    if (typeof callback == 'function') {
      yield call(callback, data);
    }
  } catch (error) {
    yield put(orderAaction.reportExportXlsError(error))
  }
}


function* salaryReportDetailWatcher() {
  yield [
    takeLatest(salaryConstant.SALARY_REPORT_DETAIL_NVKD_REQUESTING, salaryReportDetailNvkdRequestFlow),
    takeLatest(salaryConstant.SALARY_REPORT_DETAIL_LIST_REQUESTING, salaryReportDetailListRequestFlow),
    takeLatest(salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
  ]
}

export default salaryReportDetailWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReportDetail/sagas.js